
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import seguimiento from './resumen-menu-procesos-seguimiento-envio.vue';
    import facturar from './resumen-menu-procesos-facturar.vue';
    import descargar from './resumen-menu-procesos-descargar.vue';
    import sicronizar from './resumen-menu-procesos-sincronizar.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            seguimiento,
            facturar,
            descargar,
            sicronizar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        Abrir()
        {
            this.Controlador.Vista.BarraDerecha.Modo = 'procesos';
        }
    }
